import ondedxp from "../../../../public/projects/smartworld/images/projects/onedxp.webp";
import sector69 from "../../../../public/projects/smartworld/images/projects/sector69.webp";
import theedition from "../../../../public/projects/smartworld/images/projects/theedition.webp";
import logo from "../../../../public/projects/smartworld/images/logo/logo.png";

// SkyArc
import overviewImage_skyarc from "../../../../public/projects/smartworld/images/skyarc/Overview/1.webp";
import bannerDesktopImage_skyarc from "../../../../public/projects/smartworld/images/skyarc/Banner/1.webp";
import bannerMobileImage_skyarc from "../../../../public/projects/smartworld/images/skyarc/Banner/2.webp";
import siteVisitBannerImage_skyarc from "../../../../public/projects/smartworld/images/skyarc/SiteVisitBanner/1.webp";
import Location_skyarc from "../../../../public/projects/smartworld/images/skyarc/Location/L1.webp";
import Hightlights_skyarc from "../../../../public/projects/smartworld/images/skyarc/Highlights/1.webp";
import image1BHK_skyarc from "../../../../public/projects/smartworld/images/skyarc/floorplan/1.webp";
import image2BHK_skyarc from "../../../../public/projects/smartworld/images/skyarc/floorplan/2.webp";
import location_skyarc from "../../../../public/projects/smartworld/images/skyarc/Overview/l.png";
import cal_skyarc from "../../../../public/projects/smartworld/images/skyarc/Overview/c.png";
import newlaunch_skyarc from "../../../../public/projects/smartworld/images/skyarc/Overview/n.png";
import g1_skyarc from "../../../../public/projects/smartworld/images/skyarc/Gallery/1.webp";
import g2_skyarc from "../../../../public/projects/smartworld/images/skyarc/Gallery/2.webp";
import g3_skyarc from "../../../../public/projects/smartworld/images/skyarc/Gallery/3.webp";
import g4_skyarc from "../../../../public/projects/smartworld/images/skyarc/Gallery/4.webp";
import g5_skyarc from "../../../../public/projects/smartworld/images/skyarc/Gallery/5.webp";

// The Edition
import overviewImage_theedition from "../../../../public/projects/smartworld/images/the_edition/Overview/1.webp";
import bannerDesktopImage_theedition from "../../../../public/projects/smartworld/images/the_edition/Banner/1.webp";
import bannerMobileImage_theedition from "../../../../public/projects/smartworld/images/the_edition/Banner/2.webp";
import siteVisitBannerImage_theedition from "../../../../public/projects/smartworld/images/the_edition/SiteVisitBanner/1.webp";
import Location_theedition from "../../../../public/projects/smartworld/images/the_edition/Location/L1.webp";
import Hightlights_theedition from "../../../../public/projects/smartworld/images/the_edition/Highlights/1.webp";
import image1BHK_theedition from "../../../../public/projects/smartworld/images/the_edition/floorplan/1.webp";
import image2BHK_theedition from "../../../../public/projects/smartworld/images/the_edition/floorplan/2.webp";
import location_theedition from "../../../../public/projects/smartworld/images/the_edition/Overview/l.png";
import cal_the_edition from "../../../../public/projects/smartworld/images/the_edition/Overview/c.png";
import newlaunch_theedition from "../../../../public/projects/smartworld/images/the_edition/Overview/n.png";
import g1_theedition from "../../../../public/projects/smartworld/images/the_edition/Gallery/1.webp";
import g2_theedition from "../../../../public/projects/smartworld/images/the_edition/Gallery/2.webp";
import g3_theedition from "../../../../public/projects/smartworld/images/the_edition/Gallery/3.webp";
import g4_theedition from "../../../../public/projects/smartworld/images/the_edition/Gallery/4.webp";
import g5_theedition from "../../../../public/projects/smartworld/images/the_edition/Gallery/5.webp";

// One DXP
import overviewImage_onedxp from "../../../../public/projects/smartworld/images/onedxp/Overview/1.webp";
import bannerDesktopImage_onedxp from "../../../../public/projects/smartworld/images/onedxp/Banner/1.webp";
import bannerMobileImage_onedxp from "../../../../public/projects/smartworld/images/onedxp/Banner/2.webp";
import siteVisitBannerImage_onedxp from "../../../../public/projects/smartworld/images/onedxp/SiteVisitBanner/1.webp";
import Location_onedxp from "../../../../public/projects/smartworld/images/onedxp/Location/L1.webp";
import Hightlights_onedxp from "../../../../public/projects/smartworld/images/onedxp/Highlights/1.webp";
import image1BHK_onedxp from "../../../../public/projects/smartworld/images/onedxp/floorplan/1.webp";
import image2BHK_onedxp from "../../../../public/projects/smartworld/images/onedxp/floorplan/2.webp";
import image3BHK_onedxp from "../../../../public/projects/smartworld/images/onedxp/floorplan/3.webp";
import location_onedxp from "../../../../public/projects/smartworld/images/onedxp/Overview/l.png";
import cal_onedxp from "../../../../public/projects/smartworld/images/onedxp/Overview/c.png";
import newlaunch_onedxp from "../../../../public/projects/smartworld/images/onedxp/Overview/n.png";
import g1_onedxp from "../../../../public/projects/smartworld/images/onedxp/Gallery/1.webp";
import g2_onedxp from "../../../../public/projects/smartworld/images/onedxp/Gallery/2.webp";
import g3_onedxp from "../../../../public/projects/smartworld/images/onedxp/Gallery/3.webp";
import g4_onedxp from "../../../../public/projects/smartworld/images/onedxp/Gallery/4.webp";
import g5_onedxp from "../../../../public/projects/smartworld/images/onedxp/Gallery/5.webp";

export const developersSmartworld = {
  name: `Smartworld Properties in Gurugram`,
  properties: [
    {
      name: "Smartworld - The Edition",
      image: theedition,
      price: "On Request",
      location: "Sector 66",
      state: "Gurugram",
      projectlocation: "Golf Course Extention Road",
      developer: "Smartworld",
      bed: "3 - 4 BHK ",
      size: "On Request",
      url: `/smartworld-edition-sector-66-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    // {
    //   name: "Smartworld - Sector 69",
    //   image: sector69,
    //   price: "On Request",
    //   location: "Gurgaon",
    //   bed: "1 - 3 BR Apartments",
    //   size: "On Request",
    //   url: `/developers/smartworld/smartworld-sector69`,
    // },
    {
      name: "Smartworld - One dxp",
      image: ondedxp,
      price: "On Request",
      location: "Sector 113",
      bed: "2 - 4 BHK ",
      state: "Gurugram",
      projectlocation: "Dwarka Expressway",
      developer: "Smartworld",
      size: "....",
      url: `/smartworld-one-dxp-sector113-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Smartworld - Skyarc",
      image: sector69,
      price: "On Request",
      location: "Sector 69",
      projectlocation: "Golf Course Extention Road",
      bed: "3.5 - 4.5 BHK ",
      size: "....",
      state: "Gurugram",
      developer: "Smartworld",
      url: `/smartworld-skyarc-sector-69-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: `2021`,
    projects: `118`,
    ongoingprojects: `18`,
  },
  about: `Smartworld is a new age real estate company envisioned to be the future of real estate in
   India. We are driven by the core values of Customer Centricity, Professionalism and Digital First, 
   and are committed to bringing a refreshing change to the real estate sector not just with our unique 
   concepts of living but also with our utmost belief in transparency, honesty and commitment. Incepted in
    2021, Smartworld Developers is backed by reputed organisations and financial robust founders and envisages 
    transforming the real estate scenario and setting benchmarks through its vision of bringing world-class real
     estate assets to India, utilizing the most advanced and smart technologies to set new benchmarks in construction, 
     operations, customer service, unmatched delivery schedules and friendly customer-price points. 
     The company has amalgamated some of the revered names in the real estate industry whose experience
      of Sales, Marketing, Product Design and Project Management Delivery exceeds over Rs. 50 billion in
       sales and 1 billion sq. ft. in project execution.`,
};
export const projectssmartworld = {
  smartworld_skyarc: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_skyarc,
      bannerMobileImage: bannerMobileImage_skyarc,
      textOverlay: "",
      data: {
        title: "Smartworld Sky Arc",
        subtitle: "Sector 69, Gurgaon",
        starting_price: "4.7 Cr*",
        payment_plan: "CLP",
        rerano: "RC/REP/HARERA/GGM/878/610/2024/105",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Smart World Sky Arc",
      description: [
        `SmartWorld Sky Arc in Sector 69, Gurugram, enjoys a prime location in one of the city’s fastest-growing sectors. Known for its excellent 
      connectivity and proximity to key business hubs, this thriving area is an ideal choice for working professionals, families, and investors alike.
       Offering a diverse selection of residential units—including 3.5BHK and 4.5BHK Apartments & Penthouses—this development integrates modern features
        and amenities to suit various lifestyle preferences and budgets.

The design philosophy behind Smart World Sky Arc Gurgaon is a fusion of sophistication, functionality, and contemporary appeal. Inspired by
 international architectural standards, the development harmonizes aesthetics with practicality. Spanning across vast acres of land, it offers 
 ample green spaces and open areas, ensuring a peaceful retreat amidst the city’s dynamic pulse. The master plan prioritizes a seamless balance 
 between construction and nature, creating an environment that promotes serenity and well-being.`,
      ],
      image: overviewImage_skyarc,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_skyarc,
          title: "4.7 Cr*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_skyarc,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_skyarc,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_skyarc,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2355 - 2690 sq. ft.",
          price: "4.7 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "3270 sq. ft.",
          price: "6.5 Cr*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        ttype: "3 BHK",
        area: "2355 - 2690 sq. ft.",
        price: "4.7 Cr*",
        image: image1BHK_skyarc,
      },
      {
        type: "4 BHK",
        area: "3270 sq. ft.",
        price: "6.5 Cr*",
        image: image2BHK_skyarc,
      },
    ],

    highlights: {
      images: Hightlights_skyarc,
      tagline: "Highlights",
      features: [
        " Gurgaon's Luxury Apartments in Sector 69 have exquisite fixtures and finishes.",
        " Superior vitrified tiles are utilized in the kitchen, living spaces.",
        "  It also features outstanding interior design.",
        " There are high-speed elevators in the facilities.",
        "Easy parking is available at Apartments to save hassles.",
      ],
    },

    location: {
      image: Location_skyarc,
      data:[
        {
          airport:{
            distance_time:"22 kms",
            name:"Indira Gandhi International Airport"
          },
          school:{
            distance_time:"4.3 Kms",
            name:"Ashoka International School"
          },
          railwayormetro:{
            distance_time:"12.6 Kms",
            name:"Gurugram Railway Station"
          },
          hospital:{
            distance_time:"5.1 Kms",
            name:"Park Hospital"
          },
          mall:{
            distance_time:"5.1 Kms",
            name:"Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_skyarc },
        { image: g2_skyarc },
        { image: g3_skyarc },
        { image: g4_skyarc },
        { image: g5_skyarc },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Smartworld Sky ARC, kindly share more details.",
    },
    faq: [
      {
        question: "Where is Smartworld Sky Arc located?",
        answer: `Smartworld Sky Arc is located in Sector 69, Gurgaon, near Golf Course Extension Road, ensuring excellent connectivity to key areas like Sohna Road, NH-48, and Cyber City.`,
      },
      {
        question: "What types of apartments are available in Smartworld Sky Arc?",
        answer: `The project offers spacious 3 BHK and 4 BHK apartments with contemporary designs, premium fittings, and high-end specifications.`,
      },
      {
        question: "What are the key amenities at Smartworld Sky Arc?",
        answer: `Residents can enjoy world-class amenities, including a clubhouse, swimming pool, gym, landscaped gardens, kids’ play area, jogging track, sports facilities, and 24/7 security.`,
      },
      {
        question: "What is the starting price of apartments in Smartworld Sky Arc?",
        answer: `The pricing for Smartworld Sky Arc apartments starts at approximately ₹4.7 Cr*, depending on the unit type and configuration.`,
      },
      {
        question: "What makes Smartworld Sky Arc a standout choice for homebuyers?",
        answer: `Smartworld Sky Arc in Sector 69, Gurgaon, emerges as a premier choice for homebuyers seeking an exceptional blend of luxury, architectural brilliance, and strategic location.`,
      },
      {
        question: "Who is the developer of Smartworld Sky Arc?",
        answer: `Smartworld Developers, a renowned real estate brand known for premium residential projects, is behind Smartworld Sky Arc.`,
      },
      {
        question: "What makes Smartworld Sky Arc a good investment?",
        answer: `Smartworld Sky Arc offers a prime location, high-end amenities, superior construction quality, and excellent connectivity, making it a valuable investment opportunity in Gurgaon.`,
      },
      {
        question: "Is Smartworld Sky Arc RERA registered?",
        answer: `Yes, Smartworld Sky Arc is RERA registered, ensuring transparency and adherence to regulatory guidelines.`,
      },
      {
        question: "What is the expected possession date for Smartworld Sky Arc?",
        answer: `The expected possession date for Smartworld Sky Arc is December 2027.`,
      },
      {
        question: "Does Smartworld Sky Arc offer smart home features?",
        answer: `Yes, the project includes advanced smart home automation, digital security systems, and energy-efficient designs.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Smartworld - The Edition",
          image: theedition,
          price: "On Request",
          location: "Sector 66",
          state: "Gurugram",
          projectlocation: "Golf Course Extention Road",
          developer: "Smartworld",
          bed: "3 - 4 BHK ",
          size: "On Request",
          url: `/smartworld-edition-sector-66-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Smartworld - One dxp",
          image: ondedxp,
          price: "On Request",
          location: "Sector 113",
          bed: "2 - 4 BHK ",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          developer: "Smartworld",
          size: "....",
          url: `/smartworld-one-dxp-sector113-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
     
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  smartworld_theedition: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_theedition,
      bannerMobileImage: bannerMobileImage_theedition,
      textOverlay: "",
      data: {
        title: "Smartworld The Edition",
        subtitle: "Sector 66, Gurgaon",
        starting_price: "6.2 Cr*",
        rerano: "GGM/756/488/2023/100",
        payment_plan: "30:30:40",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Smartworld The Edition",
      description: [
        ` 
Discover Smartworld The Edition in Sector 66, an exceptional under-construction residential community in Gurgaon. 
Offering a stunning selection of apartments for purchase, this exclusive development is designed to meet the needs and preferences of discerning homebuyers.  

Developed by the renowned Smart World Developers, this premium project is thoughtfully planned with modern amenities and essential facilities, 
ensuring a luxurious and comfortable lifestyle. With ownership slated for February 2031, Smartworld The Edition presents a rare opportunity to 
secure your dream home in one of Gurgaon's most highly anticipated projects.  
Don’t miss your chance to be part of this extraordinary living experience`,
      ],
      image: overviewImage_theedition,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_theedition,
          title: "6.2 Cr*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_the_edition,
          title: "30:30:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_theedition,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_theedition,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3.5 BHK + SQ",
          area: "2945 sq. ft.",
          price: "₹ 6.2 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "4.5 BHK + SQ",
          area: "3505 sq. ft.",
          price: "₹ 7.57 Cr*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3.5 BHK + SQ",
        area: "2945 sq. ft.",
        price: "₹ 6.2 Cr*",
        image: image1BHK_theedition,
      },
      {
        type: "4.5 BHK + SQ",
        area: "3505 sq. ft.",
        price: "₹ 7.57 Cr*",
        image: image2BHK_theedition,
      },
    ],

    highlights: {
      images: Hightlights_theedition,
      tagline: "Highlights",
      features: [
        " Located in three high-rise twin towers.",
        " Luxury apartments with 3.5 and 4.5 BHK.",
        " Rooftop infinity edge swimming pool.",
        " The property features a private jacuzzi.",
        "Two car spaces for 3.5 and 4.5 BHK units.",
      ],
    },

    location: {
      image: Location_theedition,
      data:[
        {
          airport:{
            distance_time:"25 kms",
            name:"IGI Airport"
          },
          school:{
            distance_time:"4.2 Kms",
            name:"Sri Chaitanya Techno School"
          },
          railwayormetro:{
            distance_time:"7.2 Kms",
            name:"Sector 55-56 metro station"
          },
          hospital:{
            distance_time:"1.6 Kms",
            name:"Pulse Multispecility Hospital"
          },
          mall:{
            distance_time:"2.8 Kms",
            name:"Ambience Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_theedition },
        { image: g2_theedition },
        { image: g3_theedition },
        { image: g4_theedition },
        { image: g5_theedition },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Smart World The Edition, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is Smart World The Edition located?",
        answer: `Smart World The Edition is situated in Sector 66, Gurgaon, along Golf Course Extension Road, providing excellent connectivity to key business hubs, schools, hospitals, and entertainment centers.`,
      },
      {
        question: "What types of apartments are available in Smart World The Edition?",
        answer: `The project offers luxury 3 BHK and 4 BHK apartments with spacious layouts, premium interiors, and high-end fittings.`,
      },
      {
        question: "What is the price range of apartments in Smart World The Edition?",
        answer: `The price of 3 BHK and 4 BHK apartments in Smart World The Edition starts from ₹6.2 Cr* onwards, depending on the configuration and unit size.`,
      },
      {
        question: "Who is the developer of Smart World The Edition?",
        answer: `The project is developed by Smart World Developers, a reputed real estate company known for delivering high-quality residential and commercial projects.`,
      },
      {
        question: "What makes Smart World The Edition a standout choice for homebuyers?",
        answer: `Smart World The Edition in Sector 66, Gurgaon, emerges as a premier choice for homebuyers seeking a blend of luxury, modern design, and strategic location.`,
      },
      {
        question: "What is the construction status of Smart World The Edition?",
        answer: `Smart World The Edition is currently in the pre-launch phase, and construction is expected to coming soon.`,
      },
      {
        question: "What makes Smart World The Edition unique?",
        answer: `This project stands out due to its ultra-luxury living experience, prime location, world-class amenities, and exclusive community features that cater to high-end homebuyers.`,
      },
      {
        question: "What is the possession date of Smart World The Edition?",
        answer: `The expected possession date for Smart World The Edition is Feb, 2031. `,
      },
      {
        question: "Is Smart World The Edition RERA registered?",
        answer: `Yes, Smart World The Edition is RERA registered, ensuring transparency and legal compliance. The RERA registration number is GGM/756/488/2023/100.`,
      },
      {
        question: "Are there any smart home features in Smart World The Edition?",
        answer: `Yes, the apartments come with smart home automation, voice-controlled lighting, climate control, and advanced security systems.`,
      },
    ],
    similar: {
      properties: [
     
        
        {
          name: "Smartworld - One dxp",
          image: ondedxp,
          price: "On Request",
          location: "Sector 113",
          bed: "2 - 4 BHK ",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          developer: "Smartworld",
          size: "....",
          url: `/smartworld-one-dxp-sector113-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Smartworld - Skyarc",
          image: sector69,
          price: "On Request",
          location: "Sector 69",
          projectlocation: "Golf Course Extention Road",
          bed: "3.5 - 4.5 BHK ",
          size: "....",
          state: "Gurugram",
          developer: "Smartworld",
          url: `/smartworld-skyarc-sector-69-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  smartworld_onedxp: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_onedxp,
      bannerMobileImage: bannerMobileImage_onedxp,
      textOverlay: "",
      data: {
        title: "Smart World One DXP",
        subtitle: "Sector 113, Gurgaon",
        starting_price: "₹ 3.58 Cr*",
        rerano: "GGM/645/377/2022/120",
        payment_plan: "30:30:40",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Smart World One DXP",
      description: [
        ` Smart World One DXP is an upcoming, thoughtfully designed residential project in Gurgaon, blending futuristic architecture with modern living.
       Crafted for a dynamic lifestyle, it offers state-of-the-art amenities, a multi-tier security system for peace of mind, and an eco-friendly 
       environment that promotes cleaner air. Every specification in Smart World One DXP Gurgaon is meticulously planned to enhance comfort, convenience, 
       and sustainability.

Gone are the days of ordinary, simple homes. The modern generation seeks urban, chic residences that are not just luxurious but also technologically 
advanced, tailored to personal preferences, lifestyle, and safety. This project is a seamless fusion of innovation and sophistication, designed to 
redefine contemporary living.

Offering air-conditioned apartments in 2, 3, and 4 BHK configurations, Smart World One DXP is built with precision and excellence. Unlike many 
residential projects in Gurgaon, it does not rely on extravagant claims but instead speaks for itself through superior construction quality and 
impeccable design.`,
      ],
      image: overviewImage_onedxp,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_onedxp,
          title: "₹ 3.58 Cr*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_onedxp,
          title: "30:30:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_onedxp,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_onedxp,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "1370 sq. ft.",
          price: "₹ 3.58 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1722 - 2050  sq. ft.",
          price: "₹ 4.5 - 5.36 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "2117 - 2600 sq. ft.",
          price: "₹ 5.53 - 6.79 Cr*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "1370 sq. ft.",
        price: "₹ 3.58 Cr*",
        image: image1BHK_onedxp,
      },
      {
        type: "3 BHK",
        area: "1722 - 2050  sq. ft.",
        price: "₹ 4.5 - 5.36 Cr*",
        image: image2BHK_onedxp,
      },
      {
        type: "4 BHK",
        area: "2117 - 2600 sq. ft.",
        price: "₹ 5.53 - 6.79 Cr*",
        image: image3BHK_onedxp,
      },
    ],

    highlights: {
      images: Hightlights_onedxp,
      tagline: "Highlights",
      features: [
        "Spread Over 16 Acre.",
        "Floating sauna and Scenic pool.",
        "Healthy and fresh morning walk on the rooftop with jogging track.",
        "Every modern comfort, just 1 minute away.",
        "Proximity to top-notch educational & medical facilities.",
      ],
    },

    location: {
      image: Location_onedxp,
      data:[
        {
          airport:{
            distance_time:"13.8 Kms",
            name:"IGI Airport"
          },
          school:{
            distance_time:"8.4 Kms",
            name:"The NorthCap University"
          },
          railwayormetro:{
            distance_time:"9.0 Kms",
            name:"Dwarka Sector 21, Metro Station"
          },
          hospital:{
            distance_time:"8.0 Kms",
            name:"Park Hospital"
          },
          mall:{
            distance_time:"7.5 Kms",
            name:"Pacific D21 Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_onedxp },
        { image: g2_onedxp },
        { image: g3_onedxp },
        { image: g4_onedxp },
        { image: g5_onedxp },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Smart World One DXP, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is Smart World One DXP located?",
        answer: `The project is situated in Sector 113, Gurgaon, near the Dwarka Expressway, ensuring seamless connectivity to Delhi, IGI Airport, and major business hubs.`,
      },
      {
        question: "What types of apartments are available in Smart World One DXP",
        answer: `Smart World One DXP offers 2.5 BHK, 3.5 BHK, and 4.5 BHK luxury residences designed with modern architecture and premium interiors.`,
      },
      {
        question: "What are the key amenities at Smart World One DXP?",
        answer: `The project features a clubhouse, swimming pool, fitness center, jogging track, landscaped gardens, co-working spaces, kids' play area, sports courts, and 24/7 security.`,
      },
      {
        question: "What is the price range of apartments in Smart World One DXP?",
        answer: `The price range varies based on unit size and configuration, generally starting from ₹3.5 Cr onwards. Prices may change depending on market trends and availability.`,
      },
      {
        question: "What is the total area of the Smart World One DXP project?",
        answer: `The project spans across approximately 16 acres, offering a well-planned gated community with abundant green spaces.`,
      },
      {
        question: "What makes Smart World One DXP a standout choice for homebuyers?",
        answer: `Smart World One DXP in Sector 113, Gurgaon, is a standout choice for homebuyers due to its futuristic design, premium amenities, and strategic location.`,
      },
      {
        question: "Who is the developer of Smart World One DXP?",
        answer: `The project is developed by Smart World Developers, a reputed real estate company known for delivering high-quality residential projects with innovative designs.`,
      },
      {
        question: "What is the construction status of Smart World One DXP?",
        answer: `The project is currently under construction, with possession expected as per the timeline provided by the developer.`,
      },
      {
        question: "What makes Smart World One DXP a good investment option?",
        answer: `The project's prime location on Dwarka Expressway, high-end amenities, smart home features, and strong future appreciation potential make it an attractive investment opportunity.`,
      },
      {
        question: "What are the smart home features in Smart World One DXP?",
        answer: `The apartments come with home automation, voice-controlled lighting, keyless entry, video door phones, and energy-efficient designs.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Smartworld - The Edition",
          image: theedition,
          price: "On Request",
          location: "Sector 66",
          state: "Gurugram",
          projectlocation: "Golf Course Extention Road",
          developer: "Smartworld",
          bed: "3 - 4 BHK ",
          size: "On Request",
          url: `/smartworld-edition-sector-66-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Smartworld - Skyarc",
          image: sector69,
          price: "On Request",
          location: "Sector 69",
          projectlocation: "Golf Course Extention Road",
          bed: "3.5 - 4.5 BHK ",
          size: "....",
          state: "Gurugram",
          developer: "Smartworld",
          url: `/smartworld-skyarc-sector-69-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
